<div class="flex flex-col gap-y-4">
	<ng-container
		*ngTemplateOutlet="
			createOption;
			context: {
				option: ADD_DOC_OPTIONS.CREATE_PACKAGE,
				icon: 'customer-package',
				title: 'Create a Blank Package',
				subtitle:
					'Select 1 or more documents for a specific task \(e.g., signing or final report\).',
			}
		"
	></ng-container>
	<ng-container
		*ngTemplateOutlet="
			createOption;
			context: {
				option: ADD_DOC_OPTIONS.ADD_DOCS,
				icon: 'file-text',
				title: 'Add Documents',
				subtitle: 'Choose from over 100 documents in your template library.',
			}
		"
	></ng-container>
</div>

<ng-template
	#createOption
	let-option="option"
	let-icon="icon"
	let-title="title"
	let-subtitle="subtitle"
	let-new="new"
>
	<button
		class="flex gap-x-4 items-center p-4 rounded-2xl border border-gray-200 cursor-pointer hover:bg-gray-50 duration-300"
		[class.bg-blue-50]="isSelected"
		[class.cursor-wait]="option === ADD_DOC_OPTIONS.CREATE_PACKAGE && isLoading"
		(click)="onOptionClick(option)"
		[testHook]="testHooks.OptionDiv"
		[attr.aria-label]="'Select ' + title + ' option'"
	>
		<div
			class="h-16 w-16 rounded-lg bg-wordDocumentBlue/20 flex items-center justify-center"
		>
			<ng-container *ngIf="icon !== 'customer-package'; else packageIcon">
				<i-tabler
					[name]="icon"
					class="text-wordDocumentBlue h-12 w-12"
				></i-tabler>
			</ng-container>
			<ng-template #packageIcon>
				<img
					src="/assets/icons/matter-packages/package-icon.svg"
					class="w-12 h-12"
					alt="Package Icon"
				/>
			</ng-template>
		</div>
		<div class="flex-1 text-left">
			<div class="h4">
				{{ title }} <span class="text-green">{{ new ? 'New!' : '' }}</span>
			</div>
			<div class="text-sm text-gray-500">{{ subtitle }}</div>
		</div>
		<div class="h-9 w-9 flex items-center justify-center">
			<ng-container
				*ngIf="
					option === ADD_DOC_OPTIONS.CREATE_PACKAGE && isLoading;
					else staticPackageIcon
				"
			>
				<i-tabler
					name="loader-2"
					class="text-gray-500 h-6 w-6 animate-spin"
				></i-tabler>
			</ng-container>
			<ng-template #staticPackageIcon>
				<i-tabler name="chevron-right" class="text-gray-500 h-6 w-6"></i-tabler>
			</ng-template>
		</div>
	</button>
</ng-template>
